import React, { useState } from "react";

import { Code, Typography } from "@packages/ds";
import { useIntl, FormattedMessage } from "react-intl";

import { Link } from "ds/Button";
import SettingLine from "ds/SettingLine";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";

import * as S from "./ConfigureDomainInfo.styles";

type ConfigureDomainInfoType = {
  closed?: boolean;
  hostname?: string;
};

const ConfigureDomainInfo = ({
  closed = false,
  hostname
}: ConfigureDomainInfoType) => {
  const [expanded, setExpanded] = useState(closed ? false : true);
  const environment = useSelectorWithUrlParams(environmentSelector);

  const intl = useIntl();

  return (
    <div key="configure-domain-info" style={{ marginTop: 24 }}>
      <SettingLine
        id="configure-domain-info-line"
        info={
          <S.InfoLayout>
            <span
              className="domains"
              title={intl.formatMessage({
                id: "settings.domains.config.title"
              })}
            >
              <b>
                {intl.formatMessage({ id: "settings.domains.config.title" })}
              </b>
            </span>
          </S.InfoLayout>
        }
        isOpen={expanded}
        onClick={() => setExpanded(!expanded)}
        disableBoxShadow
      >
        {expanded && (
          <S.CertificateExpanded key="configure-domain-edit">
            <Typography.BodyText className="status_active_description">
              <FormattedMessage
                id="settings.domains.configuration.description"
                values={{
                  link: txt => (
                    <Link
                      analyticId="links.domains.replacement"
                      href={intl.formatMessage({
                        id: "links.domains.replacement"
                      })}
                    >
                      {txt}
                    </Link>
                  )
                }}
              />
            </Typography.BodyText>
            <S.CopyWrapper>
              <S.CopyLabel>
                {intl.formatMessage({ id: "settings.domains.cname" })}
              </S.CopyLabel>
              <Code.Block
                isCopyable
                id={hostname ? hostname : `${environment?.edge_hostname}`}
              >
                {hostname ? hostname : `${environment?.edge_hostname}`}
              </Code.Block>
            </S.CopyWrapper>
          </S.CertificateExpanded>
        )}
      </SettingLine>
    </div>
  );
};

export default ConfigureDomainInfo;
